import { IconButton, InputAdornment as IAdorment, Paper, styled } from "@mui/material";

type Props = {
	onClick: VoidFunction;
	color: string;
};
const PaperStyle = styled(Paper)(({ theme }) => ({
	height: 14,
	width: 14,
	boxShadow: theme.shadows[4]
}));

export default function InputAdornment({ onClick, color }: Props) {
	return (
		<IAdorment position='start'>
			<IconButton sx={{ p: 0 }} onClick={onClick}>
				<PaperStyle
					sx={{
						borderRadius: 0.3,
						backgroundColor: color
					}}
				/>
			</IconButton>
		</IAdorment>
	);
}
